const experiences = [
    {
        role: "Software Engineer (AI & Backend)",
        company: "THT-Space Electrical Company Ltd.",
        companyLink: "https://www.linkedin.com/company/thtuepz/posts/?feedView=all",
        location: "Nilphamari, Rangpur",
        date: "April 2026 - Present",
        skills: "AI, ML, Deep Learning, Django"
    },
    {
        role: "Software Engineer (AI & Backend)",
        company: "Greentage Ltd.",
        companyLink: "https://www.linkedin.com/company/greentage",
        location: "Dhaka, Bangladesh",
        date: "October 2024 - March 2026",
        skills: "AI, ML, Django"
    },
    {
        role: "Software Engineer (Backend & ML)",
        company: "Intelsense AI",
        companyLink: "https://www.intelsense.ai/",
        location: "Dhaka, Bangladesh",
        date: "April 2024 - October 2024",
        skills: "Django, FastAPI, ML, React"
    },
    {
        role: "Intern Software Engineer (Backend & ML)",
        company: "Intelsense AI",
        companyLink: "https://www.intelsense.ai/",
        location: "Dhaka, Bangladesh",
        date: "April 2024 - October 2024",
        skills: "Django, FastAPI, ML, React"
    },
    {
        role: "Smart Health Monitoring System (IOT)",
        company: "Bangladesh Bureau of Educational Information & Statistics",
        companyLink: "https://banbeis.gov.bd/",
        location: "(BANBEIS), Ministry of Education, Bangladesh",
        date: "July 2023 - July 2024",
        skills: "Raspberry Pi, Sensors, Socket Programming, Django Channels"
    },
    {
        role: "Research Assistant",
        company: "Manash Sarker, Assistant Professor",
        companyLink: "",
        location: "Patuakhali Science and Technology University",
        date: "March 2023 - October 2024",
        skills: "Deep Learning, Traffic Prediction, Spatio-Temporal Data, Time Series Analysis"
    }

];

export default experiences;
